import { graphql } from '../../generated';

export const CHANGE_EVENT_VENUE_LAYOUT = graphql(`
  mutation ChangeEventVenueLayout($eventId: ID!, $venueLayoutId: ID!) {
    changeEventVenueLayout(input: { eventId: $eventId, venueLayoutId: $venueLayoutId }) {
      event {
        id
        venue {
          id
          slug
          name
          address {
            city
            countryCode
          }
        }
        venueLayoutId
        venueLayout {
          id
          name
        }
      }
    }
  }
`);
